import React, { useState, useEffect, useContext } from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { ThemeContext } from 'styled-components';
import Typewriter from 'typewriter-effect';
import endpoints from '../constants/endpoints';
import Social from './Social';
import FallbackSpinner from './FallbackSpinner';

const styles = {
  photo: {
    width: 160,
    height: 160,
    borderRadius: '50%',
    objectFit: 'cover',
    display: 'block',
    margin: '24px auto 18px',
  },
  nameStyle: {
    fontSize: 'clamp(2.5em, 10vw, 5em)',
    margin: 0,
  },
  rolesStyle: {
    minHeight: '2.5em',
    marginTop: '0.5em',
  },
  pitchStyle: {
    fontSize: 'clamp(1em, 3.5vw, 1.25em)',
    margin: '0.75em 0 0',
    lineHeight: 1.5,
  },
  ctaRow: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: 10,
    marginTop: '1.5em',
  },
  mainContainer: {
    minHeight: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: 0,
    padding: '0 1.25em 1.5em',
  },
  hero: {
    width: '100%',
    textAlign: 'center',
  },
  pitchBlock: {
    maxWidth: '34em',
    margin: '0.25em auto 0',
    textAlign: 'left',
  },
};

function Home() {
  const theme = useContext(ThemeContext);
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch(endpoints.home, {
      method: 'GET',
    })
      .then((res) => res.json())
      .then((res) => setData(res))
      .catch((err) => err);
  }, []);

  const variant = `outline-${theme.bsSecondaryVariant}`;

  return data ? (
    <div className="fade-in" style={styles.mainContainer}>
      <div className="home-hero" style={styles.hero}>
        {data.imageSource && (
          <img
            src={data.imageSource}
            alt={data.imageAlt}
            style={{
              ...styles.photo,
              boxShadow: `0 0 0 2px ${theme.socialIconBgColor}`,
            }}
          />
        )}
        <h1 style={styles.nameStyle}>{data.name}</h1>
        <div style={styles.rolesStyle}>
          <Typewriter
            options={{
              loop: true,
              autoStart: true,
              strings: data.roles,
              delay: 40,
              deleteSpeed: 20,
              pauseFor: 1200,
            }}
          />
        </div>
        <div style={styles.pitchBlock}>
          {[].concat(data.pitch || []).map((line) => (
            <p key={line} style={styles.pitchStyle}>{line}</p>
          ))}
        </div>
        <div style={styles.ctaRow}>
          {data.ctas?.map((cta) => (cta.href.startsWith('/') ? (
            <Button key={cta.href} as={Link} to={cta.href} variant={variant}>
              {cta.text}
            </Button>
          ) : (
            <Button key={cta.href} href={cta.href} variant={variant}>
              {cta.text}
            </Button>
          )))}
        </div>
        <Social />
      </div>
    </div>
  ) : <FallbackSpinner />;
}

export default Home;
